module.exports = __webpack_public_path__ + "media/images/wedding/21-30fbff985696107490f5dce1e8cbf580.jpg";